import { Button } from "@mui/material";
import MissingDataTable from "./MissingDataTable";
import BankFormatTable from "./BankFormatTable";

export function DelistedEntityTables({
  showCompareTable,
  showBankFormat,
  compareResult,
  handleGenerateBankFormat,
  handleDownloadExcel,
  modalPreviewTableData
}) {
  return (
    <>
      {showCompareTable && !showBankFormat && (
        <>
          <MissingDataTable compareResult={compareResult} />
          <div className="d-flex justify-content-center mt-2">
            <Button variant="contained" color="primary" className="btn createButton" onClick={handleGenerateBankFormat} disabled={compareResult.length === 0}>Generate</Button>
          </div>
        </>
      )}
      {showBankFormat && (
        <>
          <div className="d-flex justify-content-end mt-2 mb-4">
            <Button variant="contained" color="primary" className="btn createButton" onClick={handleDownloadExcel}>Download</Button>
          </div>
          <BankFormatTable modalPreviewTableData={modalPreviewTableData} />
        </>
      )}
    </>
  );
}
